import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SearchRegular from './search-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SearchRegular {...validProps} />;
}
SvgComponent.iconName = 'searchRegular';

export const SearchRegularIcon = svgIconWrapper(SvgComponent);
